export const SEARCH_BAR = {
  interestedIn: {
    en: 'You might be interested in',
    gr: 'Ίσως σε ενδιαφέρουν',
  },
  hotSearches: {
    en: 'Hot Searches',
    gr: 'Hot αναζητήσεις',
  },
  recentSearches: {
    en: 'You recently searched for',
    gr: 'Αναζήτησες πρόσφατα',
  },
  popularSearches: {
    en: 'Popular Searches',
    gr: 'Δημοφιλείς αναζητήσεις',
  },
  synonym: {
    en: 'Did you mean',
    gr: 'Μήπως εννοούσες',
  },
  categories: {
    en: 'Categories',
    gr: 'Κατηγορίες',
  },
  support: {
    en: 'Support',
    gr: 'Υποστήριξη',
  },
  articles: {
    en: 'Articles',
    gr: 'Άρθρα',
  },
  view_all_products: {
    en: 'View all Products',
    gr: 'Δες όλα τα Προϊόντα',
  },
  view_all_services: {
    en: 'View all Rate plans',
    gr: 'Δες όλα τα Προγράμματα',
  },
  view_all_articles: {
    en: 'View all Articles',
    gr: 'Δες όλα τα Άρθρα',
  },
  view_all_results: {
    en: 'View all Results',
    gr: 'Δες όλα τα αποτελέσματα',
  },
  topProducts: {
    en: 'Top products',
    gr: 'Top προϊόντα',
  },
  topServices: {
    en: 'Top Services',
    gr: 'Top υπηρεσίες',
  },
  productPrice: {
    en: 'Device Price',
    gr: 'Τιμή Συσκευής',
  },
  withRatePlan: {
    en: 'With Rate Plan',
    gr: 'Με Πρόγραμμα',
  },
  products: {
    en: 'Products',
    gr: 'Προϊόντα',
  },
  ratePlans: {
    en: 'Rate plans',
    gr: 'Προγράμματα',
  },
  close: {
    en: 'Close',
    gr: 'Κλείσιμο',
  },
  lookingFor: {
    en: 'I am looking for',
    gr: 'Ψάχνω για',
  },
  monthlyPay: {
    en: 'Monthly Payment',
    gr: 'Μηνιαίο Πάγιο',
  },
  noResultsFound: {
    en: 'No search results were found',
    gr: 'Δεν βρέθηκαν αποτελέσματα αναζήτησης',
  },
  discoverMore: {
    en: 'Discover more',
    gr: 'Ανακάλυψε περισσότερα'
  }
};

